import { render, staticRenderFns } from "./EditTableJustTwo.vue?vue&type=template&id=1aee0058&scoped=true&"
import script from "./EditTableJustTwo.vue?vue&type=script&lang=js&"
export * from "./EditTableJustTwo.vue?vue&type=script&lang=js&"
import style0 from "./EditTableJustTwo.vue?vue&type=style&index=0&id=1aee0058&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee0058",
  null
  
)

export default component.exports